import { Button, Box } from '@homebot/shared-ui-swashbuckle'
import { useContext } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import history from '../../../../../history'
import { InfoSvg } from '../../../../../svgs'
import { OverlayPanel } from '../../../Routing'
import { HomeValueEstimatePanel } from '../Panel'

export const MSG = defineMessages({
  button: {
    id: 'HomeValueEstimate.button.title',
    defaultMessage: 'Learn about home estimates',
  },
})

export const HomeValueEstimateButton = () => {
  const { ampli } = useContext(AmplitudeContext)
  const intl = useIntl()
  const handleOnClick = () => {
    ampli?.avmInfoViewed()
    history.push(OVERLAY_HELPERS.homeValueEstimate.buildPath())
  }

  return (
    <>
      <Box m='spacing-600'>
        <Button
          onClick={handleOnClick}
          colorScheme='btn-secondary'
          leftIcon={<InfoSvg />}
        >
          {intl.formatMessage(MSG.button)}
        </Button>
      </Box>
      <OverlayPanel
        back={OVERLAY_HELPERS.homeValueEstimate.getOrigin()}
        path={OVERLAY_HELPERS.homeValueEstimate.buildPath()}
        title={OVERLAY_HELPERS.getTitle(
          'homeValueEstimate',
          intl.formatMessage
        )}
        anchorOffset={200}
        component={HomeValueEstimatePanel}
      />
    </>
  )
}
